

















































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    NextPrevBtn,
    Footer,
  },
})
export default class ArtPerfBibliogr extends Vue {
  protected nxtprevArtPerfBibliogr = {
    BoolPrev: true,
    BoolNext: false,
    PrevImage: "/thumbnail2.png",
    NextImage: " ",
    PrevLink: "/PerformanceArtistique/CorpusdeTexte",
    NextLink: " ",
  };
}
